"use client";

import { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
export default function Slideshow() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const slides = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/commercial_water_pump_industrial.png",
    title: "Commercial Water Pumps",
    description: "Expert installation and servicing of high-capacity industrial water pumps engineered for demanding commercial environments, ensuring reliable water flow and pressure management."
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/residential_submersible_pump_system.png",
    title: "Residential Submersible Pumps",
    description: "Professional submersible pump services for residential wells, providing quiet operation and dependable water supply with expert installation and maintenance."
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/fire_pump_emergency_system.png",
    title: "Fire Pump Systems",
    description: "Specialized fire pump installation, testing, and maintenance services ensuring your fire suppression system meets all safety codes and operates flawlessly when needed."
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/booster_pump_pressure_system.png",
    title: "Booster Pump Solutions",
    description: "Custom booster pump installations and repairs delivering consistent water pressure throughout multi-story buildings and properties with pressure challenges."
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/sewage_lift_station_pump.png",
    title: "Sewage Lift Stations",
    description: "Complete sewage lift station pump services including installation, repair, and preventative maintenance to ensure efficient and trouble-free wastewater management."
  }];
  useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 5000);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
    return () => {
      clearInterval(interval);
    };
  }, [api]);
  return <section id="slideshow" className="relative w-full bg-dark-background py-16 md:py-20">
      <div className="container mx-auto px-4">
        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent>
            {slides.map((slide, i) => <CarouselItem key={i} data-index={i}>
                <div className="relative aspect-[16/9] md:aspect-[21/9] w-full overflow-hidden rounded-lg">
                  <img src={slide.image} alt={slide.title} className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-background/90 via-dark-background/40 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 lg:p-12">
                    <div className="max-w-3xl">
                      <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-3 md:mb-4">
                        {slide.title}
                      </h2>
                      <p className="text-base md:text-lg text-foreground/90 leading-relaxed">
                        {slide.description}
                      </p>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          <div className="hidden md:block">
            <CarouselPrevious className="-left-4 lg:-left-12" />
            <CarouselNext className="-right-4 lg:-right-12" />
          </div>
        </Carousel>
        <div className="flex justify-center gap-2 mt-6">
          {slides.map((_, i) => <button key={i} data-index={i} onClick={() => api?.scrollTo(i)} className={`h-2 rounded-full transition-all duration-300 ${current === i ? "w-8 bg-accent" : "w-2 bg-foreground-dark/30 hover:bg-foreground-dark/50"}`} aria-label={`Go to slide ${i + 1}`} />)}
        </div>
      </div>
    </section>;
}